(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kalania-bundles"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('kalania-bundles')) return;

    const FORMATS = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.'],
    };

    class KalaniaBundles extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section') || document;
        try {
          this.prices = JSON.parse(this.querySelector('[data-kb-variants]').textContent);
        } catch (e) {
          this.prices = {};
        }

        const tiers = this.tiers;
        const initial = tiers.find((t) => t.dataset.default === 'true') || tiers[0];
        this.selectedQty = initial ? Number(initial.dataset.quantity) : 1;

        this.onClick = (event) => {
          const tier = event.target.closest('[data-bundle-tier]');
          if (tier && this.contains(tier)) this.select(Number(tier.dataset.quantity));
        };
        this.onKeydown = (event) => {
          const tier = event.target.closest('[data-bundle-tier]');
          if (!tier) return;
          const list = this.tiers;
          const index = list.indexOf(tier);
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = list[(index + 1) % list.length];
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = list[(index - 1 + list.length) % list.length];
          if (event.key === ' ' || event.key === 'Enter') next = tier;
          if (!next) return;
          event.preventDefault();
          this.select(Number(next.dataset.quantity));
          next.focus();
        };
        // Si el cliente cambia la cantidad a mano (cuando el selector está visible), sincroniza la tarjeta.
        this.onQuantityChange = (event) => {
          if (this.syncing || !event.target.matches?.('input[name="quantity"]')) return;
          if (!this.form || !this.form.contains(event.target)) return;
          this.selectedQty = Math.max(1, Number(event.target.value) || 1);
          this.paint();
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.scope.addEventListener('change', this.onQuantityChange);

        // El tema re-renderiza el formulario al cambiar de variante (y puede resetear la cantidad a 1).
        this.observer = new MutationObserver(() => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.apply());
        });
        this.observer.observe(this.scope, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['value'],
        });

        this.apply();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.scope?.removeEventListener('change', this.onQuantityChange);
      }

      get tiers() {
        return [...this.querySelectorAll('[data-bundle-tier]')];
      }

      get form() {
        return (
          this.scope.querySelector('product-form-component form[data-type="add-to-cart-form"]') ||
          this.scope.querySelector('form[data-type="add-to-cart-form"]')
        );
      }

      get variantId() {
        return this.form?.querySelector('[name="id"]')?.value;
      }

      select(quantity) {
        this.selectedQty = quantity;
        this.apply();
      }

      apply() {
        this.paint();
        this.syncQuantity();
        this.updatePrices();
      }

      paint() {
        this.tiers.forEach((tier) => {
          const active = Number(tier.dataset.quantity) === this.selectedQty;
          if (tier.classList.contains('is-selected') !== active) tier.classList.toggle('is-selected', active);
          const checked = String(active);
          if (tier.getAttribute('aria-checked') !== checked) tier.setAttribute('aria-checked', checked);
        });
        const tiers = this.tiers;
        const focusable = tiers.find((t) => t.classList.contains('is-selected')) || tiers[0];
        tiers.forEach((t) => {
          const value = t === focusable ? '0' : '-1';
          if (t.getAttribute('tabindex') !== value) t.setAttribute('tabindex', value);
        });
        const current = this.querySelector('[data-kb-current]');
        const selected = tiers.find((t) => t.classList.contains('is-selected'));
        const label = selected?.querySelector('.k-tier__title')?.textContent.trim() || '';
        if (current && current.textContent !== label) current.textContent = label;
      }

      syncQuantity() {
        const input = this.form?.querySelector('input[name="quantity"]');
        if (!input || Number(input.value) === this.selectedQty) return;
        this.syncing = true;
        input.value = String(this.selectedQty);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncing = false;
      }

      updatePrices() {
        const unit = this.prices[this.variantId];
        if (unit == null) return;
        const noDecimals = /no_decimals/.test(this.dataset.moneyFormat || '');

        this.tiers.forEach((tier) => {
          const quantity = Number(tier.dataset.quantity) || 1;
          const discount = Number(tier.dataset.discount) || 0;
          const full = unit * quantity;
          let saved = Math.round((full * discount) / 100);
          if (noDecimals) saved = Math.round(saved / 100) * 100;
          const final = full - saved;

          this.setText(tier.querySelector('[data-kb-price]'), this.money(final));
          this.setText(tier.querySelector('[data-kb-compare]'), this.money(full));
          const footer = discount > 0
            ? (tier.dataset.savingsText || '').replace('[ahorro]', this.money(saved))
            : tier.dataset.noDiscountText || '';
          this.setText(tier.querySelector('[data-kb-footer]'), footer);
        });
      }

      setText(element, text) {
        if (element && element.textContent !== text) element.textContent = text;
      }

      money(cents) {
        const format = this.dataset.moneyFormat;
        if (!format) return '$' + Math.round(cents / 100).toLocaleString('es-CL');
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          const [precision, thousands, decimal] = FORMATS[key] || FORMATS.amount;
          const [whole, fraction] = (cents / 100).toFixed(precision).split('.');
          return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
        });
      }
    }

    customElements.define('kalania-bundles', KalaniaBundles);
  })();
  } catch(e) { console.error(e); }
})();

})();
